import { type OnrApiMutationOptions, useOnrApi } from './mutation/useOnrApi.ts'

export interface SearchJudicialRecordsApiVariables {
  volunteerCodes: string
}

export type JudicialRecordSearchResult =
  | {
      error: string
      document?: never
    }
  | {
      error?: never
      document: string
    }

export type SearchJudicialRecordsApiResponse = Record<string, JudicialRecordSearchResult>

export const useSearchJudicialRecords = (
  options?: OnrApiMutationOptions<SearchJudicialRecordsApiResponse, SearchJudicialRecordsApiVariables>
) =>
  useOnrApi<SearchJudicialRecordsApiResponse, SearchJudicialRecordsApiVariables>({
    type: 'searchJudicialRecords',
    ...options,
  })
